import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import { useNavigate } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import UploadReport from "./uploadReport";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import TestForPackage from "./testsByPackagePopup";
import FamilyAppointmentCancel from "./familyAppointmentCancelPopup";
import AppointmentReschedule from "./appointmentReschedule";
import { Pagination } from "react-bootstrap";
import { FaEdit, FaDownload } from "react-icons/fa";
import "./hm-theme.css";

function ViewAppointmentsByLabCorporate({ labcode }) {
  const [appointmentDetails, setAppointmentDetails] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
  const [isCancelPopupOpen, setIsCancelPopupOpen] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [isReschedulePopupOpen, setIsReschedulePopupOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [lab, setLab] = useState(null);

  const navigate = useNavigate();
  const userRole = JSON.parse(localStorage.getItem("data"))?.role;
  const token = JSON.parse(localStorage.getItem("data"))?.token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);
    } else {
      getData(currentPage);
    }
  }, [searchTerm]);

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const response = await axios.get(`/api/employeeappointment/getAllAppointments`, {
        params: { labId: lab?.id, query: searchTerm, page: pageNumber, size: 12 },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(response.data.content || []);
      setCurrentPage(response.data.number || 0);
      setTotalPages(response.data.totalPages || 0);
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const labRes = await axios.get(`/api/labdetails/labcode=${labcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLab(labRes.data);
      const trans = await axios.get(`/api/employeeappointment/getAllAppointments/labId=${labRes.data?.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setAppointmentDetails(trans.data.content || []);
      setCurrentPage(trans.data.number || 0);
      setTotalPages(trans.data.totalPages || 0);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleCancelClick = (appointment) => {
    setSelectedAppointment(appointment);
    setIsCancelPopupOpen(true);
  };

  const handleCloseCancelPopup = () => {
    setIsCancelPopupOpen(false);
    getData();
  };

  const handleUploadReport = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsUploadModalOpen(true);
  };

  const handleCloseUploadModal = () => {
    setIsUploadModalOpen(false);
    getData();
  };

  const handleViewReport = (reportId) => {
    const url = `/api/employee-appointment-reports/view/${reportId}`;
    axios({
      url,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      window.open(blobUrl, "_blank");
    }).catch(() => toast.error("Failed to view report."));
  };

  const handleDownloadReport = (reportId, fileName) => {
    axios({
      url: `/api/employee-appointment-reports/view/${reportId}`,
      method: "GET",
      responseType: "blob",
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      const contentType = response.headers["content-type"] || "application/octet-stream";
      const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName || "report");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    }).catch(() => toast.error("Failed to download report."));
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const [isTestsModalOpen, setIsTestsModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);

  const openTestsModal = (pkg) => {
    setSelectedPackage(pkg);
    setIsTestsModalOpen(true);
  };

  const closeTestsModal = () => {
    setSelectedPackage(null);
    setIsTestsModalOpen(false);
  };

  const handleAcceptAppointment = async (appointmentId) => {
    setLoader(true);
    try {
      await axios.post(
        "/api/employeeappointment/accept-or-reschedule",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CONFIRMED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Employee Appointment Confirmed successfully.");
      getData();
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const handleRescheduleAppointment = (appointmentId) => {
    setSelectedAppointmentId(appointmentId);
    setIsReschedulePopupOpen(true);
  };

  const handleCloseReschedulePopup = () => {
    setIsReschedulePopupOpen(false);
    getData();
  };

  const handleFetchReport = async (appointment) => {
    setLoader(true);
    try {
      await axios.post('/api/employeeappointment/fetchReport', appointment, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Report fetched successfully');
      getData();
    } catch (error) {
      handleError(error);
    } finally {
      setLoader(false);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    if (currentPage >= totalPages - 3) startPage = Math.max(0, totalPages - maxPageNumbersToShow);

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      {loader && <div className="loading"></div>}

      <div className="hm-card">
        {/* Header */}
        <div className="hm-card-header">
          <h3 className="hm-card-title">
            <i className="material-icons">event_note</i>
            Regular Appointment Details
          </h3>
          <span className="hm-badge hm-badge-primary">{appointmentDetails.length} Appointments</span>
        </div>

        {/* Search */}
        <div className="hm-card-body border-bottom bg-light bg-opacity-50 p-3">
          <div className="row">
            <div className="col-md-6 col-lg-5">
              <div className="position-relative">
                <input
                  type="search"
                  className="form-control ps-4"
                  placeholder="Search by company code, phone number, or package..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="material-icons position-absolute text-muted" style={{ left: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "1.1rem" }}>
                  search
                </i>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="hm-card-body p-0">
          <div style={{ overflowX: "auto" }}>
            <table className="hm-table">
              <thead>
                <tr>
                  <th>Sl.No.</th>
                  <th>Patient Name</th>
                  <th>Date</th>
                  <th>Company</th>
                  <th>Contact Number</th>
                  <th>Package / Tests</th>
                  <th>Status</th>
                  <th>Reports</th>
                  <th>Order Status</th>
                </tr>
              </thead>
              <tbody>
                {appointmentDetails.length === 0 ? (
                  <tr>
                    <td colSpan="9">
                      <div className="hm-empty-state">
                        <i className="material-icons">event_busy</i>
                        <p>{loader ? "Loading appointments..." : "No Data Available"}</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  appointmentDetails.map((appointment, index) => (
                    <tr key={appointment.id}>
                      <td className="fw-semibold">{index + 1}</td>
                      <td>
                        <span
                          className="fw-semibold text-primary cursor-pointer"
                          style={{ cursor: "pointer" }}
                          title="Upload Report"
                          onClick={() => {
                            if (
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED' &&
                              appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED'
                            ) {
                              handleUploadReport(appointment.id);
                            }
                          }}
                        >
                          {appointment.fam?.name ? appointment.fam.name : `${appointment.emplo?.name || ''} ${appointment.emplo?.lastname || ''}`}
                        </span>
                      </td>
                      <td className="small text-muted">{appointment.date}</td>
                      <td className="fw-medium">{appointment.company?.companyname || "—"}</td>
                      <td className="small">{appointment.emplo?.phoneno || "—"}</td>
                      <td>
                        {appointment.pack !== null && (
                          <div className="d-flex align-items-center gap-2 mb-1">
                            <span className="hm-badge hm-badge-primary">{appointment.pack?.packagename}</span>
                            <FiInfo
                              onClick={() => openTestsModal(appointment.packageid)}
                              className="text-primary cursor-pointer"
                              style={{ cursor: "pointer" }}
                              title="View Included Tests"
                            />
                          </div>
                        )}
                        {appointment.additionalTest && appointment.additionalTest.length > 0 && (
                          <div className="extra-small text-muted">
                            <span className="fw-semibold">Additional:</span>
                            <ul className="mb-0 ps-3">
                              {appointment.additionalTest.map((test, i) => (
                                <li key={i}>{test.testDetails?.testname}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </td>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          <span className={
                            appointment.appointmentstatus?.includes("COMPLETED") || appointment.appointmentstatus?.includes("CONFIRMED") ? "hm-badge hm-badge-success" :
                            appointment.appointmentstatus?.includes("CANCELLED") ? "hm-badge hm-badge-danger" :
                            "hm-badge hm-badge-warning"
                          }>
                            {appointment.appointmentstatus}
                          </span>
                          {(appointment.appointmentstatus !== 'APPOINTMENT CANCELLED' && appointment.appStatus?.appointmentStatus !== 'APPOINTMENT CANCELLED') &&
                            (appointment.appointmentstatus !== 'APPOINTMENT COMPLETED' && appointment.appStatus?.appointmentStatus !== 'APPOINTMENT COMPLETED') && (
                            <div className="d-flex flex-wrap gap-1 mt-1">
                              {((appointment.appStatus?.appointmentStatus === 'APPOINTMENT CONFIRMATION PENDING WITH LAB') ||
                                (appointment.appStatus?.appointmentStatus === 'APPOINTMENT RESCHEDULED' &&
                                  (appointment.appStatus?.updatedBy !== 'Lab') && (appointment.appStatus?.updatedBy !== 'Lab Corporate'))) && (
                                <button
                                  className="btn btn-success btn-sm rounded-pill px-2 py-0 extra-small"
                                  onClick={() => handleAcceptAppointment(appointment.id)}
                                >
                                  Accept
                                </button>
                              )}
                              <button
                                className="btn btn-outline-danger btn-sm rounded-pill px-2 py-0 extra-small"
                                onClick={() => handleCancelClick(appointment)}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-outline-warning btn-sm rounded-pill px-2 py-0 extra-small"
                                onClick={() => handleRescheduleAppointment(appointment.id)}
                              >
                                Reschedule
                              </button>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>
                        {appointment.orderStatus ? (
                          appointment.orderStatus?.appointmentReport ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <a
                                href={appointment.orderStatus.appointmentReport}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm rounded-pill px-2 py-0 extra-small"
                              >
                                View Report
                              </a>
                            ) : (
                              <span className="hm-badge hm-badge-warning extra-small">PENDING APPROVAL</span>
                            )
                          ) : (
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill px-2 py-0 extra-small"
                              onClick={() => handleFetchReport(appointment)}
                            >
                              Fetch Report
                            </button>
                          )
                        ) : (
                          appointment.reportstatus ? (
                            appointment.reportstatus === 'APPROVED' ? (
                              <div>
                                {(appointment.reports || []).length > 0 ? (
                                  <ul className="list-unstyled mb-0">
                                    {(appointment.reports || []).map((report, ri) => (
                                      <li key={report.id} className="d-flex align-items-center gap-1 mb-1">
                                        <span
                                          className="text-primary text-truncate cursor-pointer small"
                                          onClick={() => handleViewReport(report.id)}
                                          title={report.fileName || `File ${ri + 1}`}
                                        >
                                          {report.fileName || `File ${ri + 1}`}
                                        </span>
                                        <FaDownload
                                          size={12}
                                          className="text-success cursor-pointer"
                                          title="Download"
                                          onClick={() => handleDownloadReport(report.id, report.fileName)}
                                        />
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <span className="text-muted extra-small">No files</span>
                                )}

                                {(userRole === "ROLE_ADMIN" || userRole === "ROLE_SUPER") && (
                                  <FaEdit
                                    className="text-secondary cursor-pointer mt-1"
                                    size={14}
                                    onClick={() => handleUploadReport(appointment.id)}
                                    title="Modify Report"
                                  />
                                )}
                              </div>
                            ) : (
                              <span className="hm-badge hm-badge-warning extra-small">PENDING APPROVAL</span>
                            )
                          ) : (
                            <span className="text-muted extra-small">No Report</span>
                          )
                        )}
                      </td>
                      <td>
                        <div className="small fw-semibold">{appointment.orderStatus?.status || "—"}</div>
                        {appointment.orderStatus?.orderId && (
                          <code className="extra-small">{appointment.orderStatus.orderId}</code>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center py-3">
              <Pagination className="hm-pagination">
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage >= totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage >= totalPages - 1} />
              </Pagination>
            </div>
          )}
        </div>
      </div>

      {isUploadModalOpen && (
        <UploadReport
          isOpen={isUploadModalOpen}
          onRequestClose={handleCloseUploadModal}
          empId={selectedAppointmentId}
        />
      )}

      {isTestsModalOpen && (
        <TestForPackage
          isOpen={isTestsModalOpen}
          onRequestClose={closeTestsModal}
          packageId={selectedPackage}
        />
      )}

      {isCancelPopupOpen && (
        <FamilyAppointmentCancel
          isOpen={isCancelPopupOpen}
          onRequestClose={handleCloseCancelPopup}
          appointment={selectedAppointment}
        />
      )}

      {isReschedulePopupOpen && (
        <AppointmentReschedule
          isOpen={isReschedulePopupOpen}
          onRequestClose={handleCloseReschedulePopup}
          appointmentId={selectedAppointmentId}
        />
      )}
    </div>
  );
}

export default ViewAppointmentsByLabCorporate;

